import { ModelTableView } from '@/assets/js/ModelView'
import * as C from '../list'

const location = new ModelTableView([
	...Object.values(C)
]);

location.visibleProperties(location.props.filter(p => p.subgroup));

export default location;



// WEBPACK FOOTER //
// ./src/services/components/views/entity.js